module.exports = __webpack_public_path__ + "img/absolute-radio-80s.5f3a3d43.png";